import React from 'react';
import * as _ from 'lodash';
import fetchMg from '../../utilities/fetchManager';
import { input } from '../../utilities/inputObjects';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import moment from 'moment';
import { Modal } from '../Modal';
import { messageUtility } from '../../utilities/messageUtility';
import { api } from '../../canvas/common/api';
import dialogLoader from '../../utilities/dialogLoader';
import { LoadingModal } from '../modals/common/LoadingModal';
import { PasswordPolicyService } from '../../services/PasswordPolicyService';
import PrintUtility from '../../utilities/printUtility';
import { FILE_CODE, DATE_TIME_FORMAT } from '../../utilities/constants';

// いろんな画面で使うのでタイプをセットする
// 呼ぶときにdialogTypeに入れて呼ぶ
export const DialogType = {
  // 協力会社BOX詳細用
  PARTNER_BOX_DETAIL: 'partner_box_detail',
  // 施工体系図
  FIELD_TREE: 'field_tree',
  // 自社ユーザー一覧
  USERS_LIST: 'users_list',
};

/**
 * "職長の初期パスワードを再発行"のダイアログ
 * ●以下の3種類ある
 * ・協力会社BOX詳細（https://e-reverse.backlog.jp/view/BLDE_V2-8135）
 * ・施工体系図（https://e-reverse.backlog.jp/view/BLDE_V2-10360）
 * ・自社ユーザー一覧（https://e-reverse.backlog.jp/view/BLDE_V2-8174）
 */
export default class ForemanNewPasswordDialog extends React.Component {
  constructor(props) {
    super(props);

    /*
     * this.props.dialog.paramsは長いので短くする
     * [paramsに格納されている値]
     * dialogType
     * fieldId
     * fieldTreeId
     * companyBranchId
     */
    this.params = this.props.dialog.params;

    // ダウンロードのボタンの参照
    this.exportRef = null;

    this.updatingFlag = false;

    this.state = {
      foremen: {},
      checkAll: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    if (this.params.dialogType === DialogType.USERS_LIST) {
      // param :company_branch_id, :number, desc: "支店ID"
      const params = {
        company_branch_id: this.params.companyBranchId,
      };

      this.loadForemen(params);
    } else {
      this.loadForemen();
    }
  }

  /**
   * API実行
   * その協力会社BOX詳細に表示されてる未ログイン（sessions.updated_own_password_flag=0）の職長を対象とする。
   *
   * @params {*} [params={}] パラメータ。「自社ユーザー一覧」しか使わない
   * @memberof ForemanNewPasswordDialog
   */
  async loadForemen(params = {}) {
    // APIのパスを動的に変える
    const apiPath = this.getAPIPath();

    const apiResult = await fetchMg
      .GetAjax(apiPath, params)
      .catch(() => ({ result: false }));

    // 正しいとき
    if (apiResult.result) {
      let activeForemen = apiResult.data.entities.users;
      this.setState({
        foremen: activeForemen,
      });
    }
  }

  /**
   * 用途によってAPIのパスを生成する
   *
   * @returns
   * @memberof ForemanNewPasswordDialog
   */
  getAPIPath() {
    // 3箇所あるのでURLパスを動的に変化させる
    let apiPath = '';

    switch (this.params.dialogType) {
      case DialogType.PARTNER_BOX_DETAIL:
        // 施工体系図 => 協力会社BOX詳細 用
        // api :GET, '/api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/not_login_foreman_list'
        // '協力会社BOX未ログイン職長一覧取得API'
        apiPath = `/api/private/fields/${this.params.fieldId}/field_trees/${
          this.params.fieldTreeId
        }/field_tree_users/not_login_foreman_list`;
        break;
      case DialogType.FIELD_TREE:
        // 施工体系図 用
        // api :GET, '/api/private/fields/:field_id/field_trees/not_login_foreman_list'
        // '施工体系図未ログイン職長一覧取得API'
        apiPath = `/api/private/fields/${
          this.params.fieldId
        }/field_trees/not_login_foreman_list`;
        break;
      case DialogType.USERS_LIST:
        // 自社ユーザー一覧 用
        // api :GET, '/api/private/users/not_login_foreman_list'
        // '自社ユーザー未ログイン職長一覧取得API'
        // param :company_branch_id, :number, desc: "支店ID"
        apiPath = '/api/private/users/not_login_foreman_list';
        break;
      default:
        break;
    }

    return apiPath;
  }

  /**
   * 職長ユーザー達のコンポーネント
   */
  ForemenComponent() {
    const style = {
      fontSize: '12px',
      color: '#7C7C7C',
      padding: '8px',
      textAlign: 'center',
    };

    if (!_.size(this.state.foremen)) {
      return (
        <tr onClick={this.selectRow} className='table__item'>
          <td className='value-table'>
            <div style={style}>{messageUtility.getMessage('E-001-004')}</div>
          </td>
        </tr>
      );
    }

    return _.map(this.state.foremen, (foreman, index) => {
      return (
        <ForemanRow
          key={`foreman_row_${foreman.user_id}_${index}`}
          data={foreman}
          callback={this.pushCheckedForeman.bind(this)}
        />
      );
    });
  }

  /**
   * チェックする処理
   *
   * @param {numbr} userId user_id
   * @param {boolean} checked チェックしたか
   * @memberof ForemanNewPasswordDialog
   */
  pushCheckedForeman(userId, checked) {
    // パラメータ用
    let paramForemen = _.cloneDeep(this.state.foremen);
    paramForemen = _.map(paramForemen, foreman => {
      if (foreman.user_id === userId) {
        foreman['checked'] = !checked;
      }

      return foreman;
    });

    // keyは複数形に注意
    this.setState({ foremen: paramForemen });
    // console.log('pushCheckedForeman:', paramForemen);
  }

  /**
   * CSVを出力する
   *
   * @returns
   * @memberof ForemanNewPasswordDialog
   */
  async Submit(type) {
    // 外部ユーザーの場合、表示権限エラー画面に遷移
    if (SessionStorageService.isExtraProxiLogin()) {
      return window.location.replace('/error-permission');
    }

    // チェック1件もないのでダウンロードさせない
    if (this.canNotDownload()) {
      return;
    }

    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }

    // チェックしたの抽出しuser_idをpluck
    const checkedForemanUserIds = this.state.foremen.flatMap(item =>
      item.checked ? item.user_id : []
    );

    const params = { user_ids: checkedForemanUserIds };
    let apiPath;
    switch (this.params.dialogType) {
      case DialogType.PARTNER_BOX_DETAIL:
        apiPath = `api/private/fields/${this.params.fieldId}/field_trees/${
          this.params.fieldTreeId
        }/field_tree_users/reset_password`;
        break;
      case DialogType.FIELD_TREE:
        apiPath = `api/private/fields/${
          this.params.fieldId
        }/field_trees/reset_password`;
        break;
      case DialogType.USERS_LIST:
        params.company_branch_id = this.params.companyBranchId;
        apiPath = 'api/private/users/reset_password';
        break;
    }

    params.csv_token = SessionStorageService.getToken();

    await this.downloadForemanResetPassword(`${apiPath}.${type}`, params, type);
  }

  getDownloadFilename(fileType) {
    const DATE_FORMAT = 'YYYYMMDDHHmmSS';
    return `未ログイン職長リスト_${moment(new Date()).format(
      DATE_FORMAT
    )}.${fileType}`;
  }

  async downloadForemanResetPassword(apiPath, params = {}, fileType) {
    this.updatingFlag = true;
    const optionsWithToken = await api.withToken({});
    const isCsvExporting = fileType === 'csv';

    const extraOptions = {};
    if (!isCsvExporting) {
      extraOptions.responseType = 'blob';
    } else {
      params.csv_format = 'text/csv; charset=shift-jis';
    }

    this.setState({ isLoading: true }, () => {
      PrintUtility.printOrOpenBlob(
        async () => {
          try {
            const res = await PasswordPolicyService.resetPassword(
              {
                ...optionsWithToken,
                ...extraOptions,
              },
              params,
              apiPath
            );
            let data = res.data;
            if (isCsvExporting) {
              data = `\uFEFF${data}`;
            }

            const contentType = res.headers['content-type'];
            return new Blob([data], { type: contentType });
          } catch (e) {
            return false;
          }
        },
        this.getDownloadFilename(fileType),
        isCsvExporting ? FILE_CODE.CSV : FILE_CODE.PDF
      )
        .then(() => {
          return PasswordPolicyService.getUnableResetPasswordUsers(
            optionsWithToken
          );
        })
        .then(res => {
          const users = res.data.data.entities.users;
          if (_.isEmpty(users)) {
            dialogLoader.show(ConfirmationDialog, {
              title: messageUtility.getMessage('I-001-419'),
              msgDetail: messageUtility.getMessage('I-001-420'),
              callback: {
                back: () => {
                  dialogLoader.close();
                },
              },
            });
            return true;
          }

          dialogLoader.show(ListUnableResetPasswordDialog, {
            users,
            callback: {
              back: () => {
                dialogLoader.close();
              },
            },
          });

          return true;
        })
        .catch(() => {
          dialogLoader.show(ConfirmationDialog, {
            title: messageUtility.getMessage('E-001-402'),
            msgDetail: messageUtility.getMessage('E-001-403'),
            callback: {
              back: () => {
                dialogLoader.close();
              },
            },
          });
          this.updatingFlag = false;
          return true;
        })
        .then(() => {
          this.setState({ isLoading: false });
          this.updatingFlag = false;
        });
    });
  }

  /**
   * ダウンロード不可能
   *
   * @returns boolean
   * @memberof ForemanNewPasswordDialog
   */
  canNotDownload() {
    // チェックした数
    const checkedForemanUsers = _.filter(this.state.foremen, item => {
      return item.checked;
    });

    return this.isDownloading || checkedForemanUsers.length < 1;
  }

  checkAllCheckbox() {
    if (this.state.foremen) {
      let paramForemen = _.cloneDeep(this.state.foremen);
      paramForemen = _.map(paramForemen, foreman => {
        foreman['checked'] = !this.state.checkAll;
        return foreman;
      });

      this.setState({ foremen: paramForemen, checkAll: !this.state.checkAll });
    }
  }

  render() {
    return (
      <div
        className='dialog dialog--modal dialog--dialog-new-foremen'
        style={{ margin: 0 }}
      >
        <div className='dialog__header'>
          <span className='dialog__title'>職長の初期パスワードを再発行</span>
        </div>
        <div className='dialog__body'>
          <div className='dialog__introduction'>
            <p>
              初回ログインを行っていない職長ユーザーの初期パスワードを再発行します。
              <br />
              この操作によってCSV・PDFの出力を行った場合、協力会社の設定状況によって協力会社のユーザーにPWリセット通知メールが送信されます。
              <br />
              <br />
              選択した職長ユーザーの初期パスワード情報を一覧で確認したい場合は、「一覧をCSVで出力」を選択してください。
              <br />
              職長ユーザーへ初期パスワード情報を印刷して配布する場合は、「印刷用PDFを出力」を選択してください。
            </p>
          </div>

          <div className='dual-panel'>
            <div className='dual-panel__item'>
              <div className='panel'>
                <div className='panel-header'>
                  <div className='panel-list new-foremen-table'>
                    <div className='top-table'>
                      <table className='table table--new-foremen-label'>
                        <thead className='table__header'>
                          <tr className='table__label'>
                            {/* チェックボックス */}
                            <th
                              className='value-table value-table--table__label'
                              style={{ width: '50px' }}
                            >
                              <label
                                htmlFor='checkbox-all'
                                className='checkbox'
                              >
                                <input
                                  className='checkbox-all'
                                  id='checkbox-all'
                                  type='checkbox'
                                  onClick={() => {
                                    this.checkAllCheckbox();
                                  }}
                                  checked={
                                    !_.isEmpty(this.state.foremen) &&
                                    _.every(this.state.foremen, x => x.checked)
                                  }
                                />
                                <i className='i-square i-2_5x' />
                              </label>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>
                                職長のログインID
                              </div>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>
                                職長の姓名
                              </div>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>
                                所属会社名
                              </div>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>
                                パスワードの発行日時
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div className='new-foremen-table-element'>
                      <table className='table'>
                        <tbody>{this.ForemenComponent()}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className='dialog__footer'
          style={{ height: 'auto', minHeight: 'auto' }}
        >
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.props.dialog.callback.back();
            }}
          >
            閉じる
          </button>
          {/* CSVのダウンロードボタン */}
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              this.Submit('csv');
            }}
            ref={event => {
              this.exportRef = event;
            }}
            disabled={this.canNotDownload()}
          >
            一覧をCSVで出力
          </button>
          <button
            className='btn-fixedsize--effective'
            onClick={() => {
              this.Submit('pdf');
            }}
            disabled={this.canNotDownload()}
          >
            印刷用PDFを出力
          </button>
          <Modal modalRoot='root' modalState={this.state.showModal}>
            <DialogSuccessError
              msg={this.state.updateMsg}
              msgDetail={this.state.updateMsgDetail}
              updateSuccess={this.state.updateSuccess}
              success={() => this.setState({ showModal: false })}
              error={() => this.setState({ showModal: false })}
            />
          </Modal>
        </div>

        <LoadingModal visible={this.state.isLoading} />
      </div>
    );
  }
}

/**
 * テーブルの一覧の1行
 *
 * @class ForemanRow
 * @extends {React.Component}
 */
class ForemanRow extends React.Component {
  constructor(props) {
    super(props);

    this.uid = `foreman_new_check_${_.uniqueId()}`;

    // 自社の会社ID
    this.myCompanyId = parseInt(SessionStorageService.getCompanyId(), 10);

    // チェックボックスのリファレンス
    this.checkRef = React.createRef();
    this.selectRow = this.selectRow.bind(this);
  }

  /**
   * チェックボックスの選択
   *
   * @memberof ForemenRow
   */
  selectRow() {
    // チェックの反映

    if (this.props.callback) {
      // PushCheckedForeman()のこと
      this.props.callback(
        this.props.data.user_id,
        this.checkRef.current.checked
      );
    }
  }

  render() {
    return (
      <tr
        onClick={this.selectRow}
        className='table__item editable'
        key={`foreman_new_${this.uid}`}
      >
        {/* チェックボックス */}
        <td className='value-table'>
          <div className='value-table__icon'>
            <div className='btn-checkbox-mini'>
              <label htmlFor={this.uid} className='checkbox'>
                <input
                  id={this.uid}
                  ref={this.checkRef}
                  type='checkbox'
                  name={this.props.data.user_id}
                  checked={this.props.data.checked || false}
                  onChange={() => {}}
                />
                <i className='i-square i-2_5x' />
              </label>
            </div>
          </div>
        </td>
        {/* 職長のログインID */}
        <td className='value-table'>
          <div className='value-table__name'>{this.props.data.login_id}</div>
        </td>
        {/* 職長の姓名 */}
        <td className='value-table'>
          <div className='value-table__name'>
            {this.props.data.name_sei}
            {this.props.data.name_mei}
          </div>
        </td>
        {/* 所属会社名 */}
        <td className='value-table'>
          <div className='value-table__name'>
            {this.props.data.company_name}
          </div>
        </td>
        {/* パスワードの発行日時 */}
        <td className='value-table'>
          <div className='value-table__name'>
            {moment(this.props.data.latestPasswordChangeDate).format(
              DATE_TIME_FORMAT.slashDateTimeFormat
            )}
          </div>
        </td>
      </tr>
    );
  }
}

const ListUnableResetPasswordDialog = props => (
  <div className='dialog dialog--modal dialog--dialog-new-foremen dialog--dialog-not-reset-password'>
    <div className='dialog__header'>
      <span className='dialog__title'>初期パスワードの再発行完了</span>
    </div>
    <div className='dialog__body'>
      <div className='dialog__introduction'>
        <p>
          選択した職長ユーザーの初期パスワードの再発行が完了しました。
          <br />
          下記のユーザーはすでに初回ログイン済みのため、初期パスワードの再発行ができませんでした。
        </p>
      </div>

      <div className='dual-panel'>
        <div className='dual-panel__item'>
          <div className='panel'>
            <div className='panel-header'>
              <div className='panel-list new-foremen-table new-foremen-table--completed'>
                <div className='top-table'>
                  <table className='table table--new-foremen-label'>
                    <thead className='table__header'>
                      <tr className='table__label'>
                        {/* チェックボックス */}
                        <th className='value-table value-table--table__label'>
                          <div className='value-table__name'>
                            職長のログインID
                          </div>
                        </th>
                        <th className='value-table value-table--table__label'>
                          <div className='value-table__name'>職長の姓名</div>
                        </th>
                        <th className='value-table value-table--table__label'>
                          <div className='value-table__name'>所属会社名</div>
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div className='new-foremen-table-element'>
                  <table className='table'>
                    <tbody>
                      {props.dialog.users.map(item => (
                        <tr key={item.login_id}>
                          <td className='value-table'>
                            <div className='value-table__name'>
                              {item.login_id}
                            </div>
                          </td>
                          <td className='value-table'>
                            <div className='value-table__name'>
                              {item.fullname}
                            </div>
                          </td>
                          <td className='value-table'>
                            <div className='value-table__name'>
                              {item.company_name || ''}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='dialog__footer'>
      <button
        className={'btn-fixedsize--sub'}
        onClick={() => {
          props.dialog.callback.back();
        }}
      >
        閉じる
      </button>
    </div>
  </div>
);

const ConfirmationDialog = props => (
  <DialogSuccessError
    msg={props.dialog.title}
    msgDetail={props.dialog.msgDetail}
    updateSuccess={true}
    success={() => {
      props.dialog.callback.back();
    }}
  />
);

/**
 * 成功・失敗のダイアログ
 *
 * @param {*} { success:成功時のクリックの処理, updateSuccess:trueなら成功表示/falseなら失敗表示, error:失敗時のクリックの処理, msg:ダイアログのメッセージ }
 */
const DialogSuccessError = ({
  success,
  updateSuccess,
  error,
  msg,
  msgDetail,
}) => (
  <div id='modal-dialog-confirm-selected' className={'modal show'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title dialog-md__title-prewrap'>{msg}</span>
      </div>
      {msgDetail ? (
        <div className='dialog-md__body dialog-md__body-prewrap text-left'>
          {msgDetail}
        </div>
      ) : null}
      <div className='dialog-md__footer'>
        {updateSuccess ? (
          <button
            id='modal-close-confirm-selected'
            className='btn-fixedsize--sub'
            onClick={success}
          >
            閉じる
          </button>
        ) : (
          <button
            id='modal-close-confirm-selected'
            className='btn-fixedsize--sub'
            onClick={error}
          >
            戻る
          </button>
        )}
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/dialogs/ForemanNewPasswordDialog.jsx